import t from "./ghl-ui.es1157.js";
const a = (o) => {
  const {
    primaryColor: r,
    errorColor: n
  } = o;
  return {
    colorError: n,
    colorLoading: r,
    height: "2px"
  };
}, i = {
  name: "LoadingBar",
  common: t,
  self: a
}, g = i;
export {
  g as default
};
